import { isObjWithKeys } from './DataHelpers';
import { TPhoneNumberFormat } from './utilsTypes';

export const getTestEnvHeadersForProxyServer = () => {
  return {
    ...(process.env.GATSBY_USE_SANDBOX === '1' && {
      'Is-Draft-Url': '1',
    }),
  };
};

export const formatPhoneNumber = (phoneNumber: TPhoneNumberFormat) => {
  if (isObjWithKeys(phoneNumber) && phoneNumber.area_code && phoneNumber.number) {
    return phoneNumber.area_code + phoneNumber.number;
  } else {
    return null;
  }
};
